module.exports = __webpack_public_path__ + "img/pr-2.2ad4a301.png";